export const handleSortTransition = (prevConfig, key) => {
    if ((prevConfig === null || prevConfig === void 0 ? void 0 : prevConfig.key) === key) {
        // If same key, cycle through: asc -> desc -> no sort
        if (prevConfig.direction === 'asc') {
            return { key, direction: 'desc' };
        }
        else {
            return null; // Remove sorting
        }
    }
    else {
        // New key, start with ascending
        return { key, direction: 'asc' };
    }
};
export const sortPools = (pools, sortConfig) => {
    if (!sortConfig)
        return pools;
    console.log('pools', pools);
    return [...pools].sort((a, b) => {
        let aValue;
        let bValue;
        switch (sortConfig.key) {
            case 'assets':
                aValue = a.pool.name.toLowerCase();
                bValue = b.pool.name.toLowerCase();
                break;
            case 'protocols':
                aValue = Array.isArray(a.pool.protocol)
                    ? a.pool.protocol.join('-').toLowerCase()
                    : a.pool.protocol.toLowerCase();
                bValue = Array.isArray(b.pool.protocol)
                    ? b.pool.protocol.join('-').toLowerCase()
                    : b.pool.protocol.toLowerCase();
                break;
            case 'apy': {
                const parseApy = (apy) => {
                    if (apy === '>10K') {
                        return 10000;
                    }
                    return parseFloat(apy);
                };
                aValue = parseApy(a.pool.apy);
                bValue = parseApy(b.pool.apy);
                break;
            }
            case 'tvl':
                aValue = parseFloat(a.pool.tvl);
                bValue = parseFloat(b.pool.tvl);
                break;
            case 'your_deposit':
                aValue = parseFloat(a.pool.yourDeposit);
                bValue = parseFloat(b.pool.yourDeposit);
                break;
            default:
                return 0;
        }
        if (sortConfig.direction === 'asc') {
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
        }
        else {
            return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
        }
    });
};
